import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface PmaxUrlModel extends BaseModel {
  variables?: { [key: string]: string } | PmaxUrlVariables;
}

export interface PmaxUrlVariables {
  Link: string;
}

export class PmaxUrlInitVariables implements PmaxUrlVariables {
  Link = '';
}

export class PmaxUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new PmaxUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
